import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NextDeliveryDate } from '@usf/ngrx-order';

@Component({
  selector: 'app-date-exception-calendar',
  templateUrl: './date-exception-calendar.component.html',
  styleUrls: ['./date-exception-calendar.component.scss'],
})
export class DateExceptionCalendarComponent implements OnInit {
  eligibleDays: number[];
  currentSelectedDate: Date | null;
  minDate: string;
  nextDeliveryDate: NextDeliveryDate;
  exceptionForm: FormGroup;
  startDate: string;
  chosenDate: string;

  constructor(
    private modalController: ModalController,
    readonly platformService: PlatformService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    const today = new Date();
    this.minDate = today.toISOString();

    const dateToDisplay = this.chosenDate
      ? this.chosenDate
      : this.nextDeliveryDate?.deliveryDate;
    this.exceptionForm = this.fb.group({
      deliveryDateControl: new FormControl(dateToDisplay),
    });
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async submitDateModal() {
    // Ionic Component is appending an incrementing time offset
    // which eventually overflows to the incorrect date when converted to a Moment
    // Date portion of ISO-8601 standard string is sliced to remove incrementing offset
    await this.modalController.dismiss({
      selectedDate: moment.utc(
        this.isolateDateFromISODateString(
          this.exceptionForm?.controls?.deliveryDateControl?.value,
        ),
      ),
    });
  }

  async submitDateMobile() {
    // Ionic Component is appending an incrementing time offset
    // which eventually overflows to the incorrect date when converted to a Moment
    // Date portion of ISO-8601 standard string is sliced to remove incrementing offset
    await this.modalController.dismiss({
      selectedDate: moment.utc(
        this.isolateDateFromISODateString(
          this.exceptionForm?.controls?.deliveryDateControl?.value,
        ),
      ),
    });
  }

  isEligibleDay = (dateString: string) => {
    const today = new Date().toISOString();
    if (dateString === this.isolateDateFromISODateString(today)) {
      return false;
    }
    const date = new Date(dateString);
    const utcDay = date.getUTCDay();
    //Date will be enabled if it is in the eligibleDays array.
    return this.eligibleDays.includes(utcDay);
  };

  // Ionic Component is appending an incrementing time offset
  // which eventually overflows to the incorrect date when converted to a Moment
  // Date portion of ISO-8601 standard string is sliced to remove incrementing offset
  isolateDateFromISODateString(isoDateString: string): string {
    return isoDateString.slice(0, 10);
  }
}
